
import React, { useEffect, useState, useRef, createRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
import Carregando from '../../components/Carregando/Carregando';
import { buscarMinhasFichasUtilizadas, criarCheckoutPagBank } from '../../services/api';
// cookies
import Cookies from 'js-cookie';


// css
import '../../styles/global.css';
import './MinhasFichasUtilizadas.css';

/* eslint-disable no-restricted-globals */

const MinhasFichasUtilizadas = () => {

    const navigate = useNavigate();
    // const nomeCliente = dadosCheckin?.statusCheckin.nome;

    const [fichas, setFichas] = useState([]);
    const [carregando, setCarregando] = useState(true);

    // buscar as fichas periodicamente
    const [intervalId, setIntervalId] = useState(null);

    // vamos pegar o dadosCheckin dos cookies
    const dadosCheckin = JSON.parse(Cookies.get('dadosCheckin')) || {};
    const nomeCliente = dadosCheckin.nome;
    const cpfClienteCheckin = dadosCheckin.numeroCpf;
    const nomeEstabelecimento = dadosCheckin.estabelecimento.nome;
    var valorTotalConta = 0;

    useEffect(() => {
        console.log('----- ENTROU NO MinhasFichasUtilizadas -----');

        // vamos chamar o método que carrega os dados
        loadData();

    }, []);


    useEffect(() => {
        const id = setInterval(fetchFichas, 10000); // 30 segundos
        setIntervalId(id);
        return () => clearInterval(id);
    }, []);
    
    // método que pega a localização e busca os estabelecimentos
    const loadData = async () => {
        console.log(' *** Entrou no loadData ***');
        console.log('Dados do checkin: ');
        console.log(dadosCheckin);
        try {
            await fetchFichas(); 
        } catch (err) {
            console.log("Erro ao buscar as fichas:", err);
        }
    };

  // buscar fichas já utilizadas
  const fetchFichas = async () => {
    console.log('Entrou em fetchFichas em MinhasFichasUtilizadas');

    try {
      const dados = await buscarMinhasFichasUtilizadas(dadosCheckin);

      console.log('*** fichas ***', dados.pedidos);

      if (dados?.pedidos) {
        console.log('-> Fichas: ', dados.pedidos);
        setFichas(dados.pedidos);
        setCarregando(false);
      }
    } catch (error) {
      console.error('Erro ao buscar as fichas:', error);
    }
  };


  if (carregando) {
    return <Carregando />;
  }

  return (
    <div autoFocus className="fichas-container">
      <TituloComponent />

      <h1 className="sub-titulo">Fichas já utilizadas</h1>

      {
        fichas.length > 0 ? (
          <div className="box-dados">
            {
              nomeCliente
              ?
              <p className="texto-welcome">{nomeCliente},</p>
              :
              <></>
            }
            
            <p className="texto-welcome">Bem-vindo ao {nomeEstabelecimento}!</p>
          </div>
        ) : (
          <div className="box-dados">
            <p className="texto-ficha-usar">Nenhuma ficha localizada.</p>
          </div>
        )

        
      }

      {/* Container de quadros */}
      {fichas.map((ficha, index) => (
          console.log('******************'),
          console.log('ficha = ', ficha),
          <div
          // Chave composta, pois um mesmo pedido pode ter mais de um produto.
            key={`${ficha.id}-${ficha.produto_estabelecimento_id}`}  
            data-index={index} // O índice para o swipeHandler identificar
            data-id={ficha.id} // O ID do ficha
            className="box-dados-ficha"
          >

          <p className="texto-ficha-numero">{ficha.produto_pedido_id}</p>
          <p className="texto-ficha-nome-produto">{ficha.nome_produto}</p>
          <p className="texto-ficha-preco">R$ {ficha.preco}</p>

        </div>
      ))}
    </div>
  );
};

export default MinhasFichasUtilizadas;

